import {Input} from 'x.vue.mixins';

export const Walls = {
    mixins: [Input],
    data () {
        return {
            walls: []
        }
    },
    created () {
        this.valueModel = this.modelValue;
        if (typeof this.valueModel.walls == 'undefined') this.valueModel.walls = [{
            a: '',
            b: '',
            openings: []
        }];
    },
    computed: {
        wallsS () {
            let wallsS = [];
            for (let iW in this.valueModel.walls) {
                let wall = this.valueModel.walls[iW];
                let wallS = wall.a*wall.b;
                
                for (let iO in wall.openings) {
                    let opening = wall.openings[iO];
                    wallS = wallS - opening.l*opening.h;
                }
                
                wallsS[iW] = wallS;
            }
            
            return wallsS;
        },
        
        S () {
            let S = 0;
            for (let iW in this.wallsS) {
                let wallS = this.wallsS[iW];
                S = S + wallS;
            }
            S = Math.ceil(S);
            return S>0?S:0;
        },
    },
    methods: {
        addWall () {
            let wall = {
                a: '',
                b: '',
                openings: []
            }
            
            this.valueModel.walls.push(wall);
            
        },
        delWall (i) {
            this.valueModel.walls.splice(i, 1);
        },
        addOpening (iW) {
            let opening = {
                h: '',
                l: '',
            }
            this.valueModel.walls[iW].openings.push(opening);
        },
        delOpening (i,iW) {
            this.valueModel.walls[iW].openings.splice(i, 1);
        },
    },
    watch: {
        S: {
            handler(val, oval) {
                this.valueModel.S = this.S;
            }
        }
    },
    template: `
	<div>
        <div class="extlist-items tn-cw-extlist">
            <div
                    v-for="(wall,iW) in valueModel.walls"
                    v-bind:id="'wall_'+iW"
                    v-bind:key="'wall_'+iW"
                    class="extlist-item tn-cw-wall"
                    v-bind:class="{error: (wallsS && wallsS[iW]<0)}"
                >
                <div class="option-item">
                    <span class="option-name">Стена {{iW+1}}</span>
                    
                    <label class="option-label">
                        <span>Длина, м</span>
                        <input type="number" v-model="valueModel.walls[iW].a">
                    </label>
                    <label class="option-label">
                        <span>Ширина, м</span>
                        <input type="number" v-model="valueModel.walls[iW].b">
                    </label>
                    
                    
                    <button class="button-option-remove button-default" v-on:click="delWall(iW)"></button>


                    <div v-if="false && wallsS && wallsS[iW]>0">
                        Площадь: {{Math.ceil(wallsS[iW])}}
                    </div>
                </div>
                <div class="option-item option-item--aperture">
                    <div class="extlist-inner-items tn-cw-extlist">
                        <div
                                v-for="(opening,iO) in wall.openings"
                                v-bind:id="'wall_'+iW+'_opening_'+iO"
                                v-bind:key="'wall_'+iW+'_opening_'+iO" 
                                class="option-inner-item"
                            >
                            
                            <span class="option-name">Проем {{iO+1}}</span>
                    
                            <label class="option-label">
                                <span>Длина, м</span>
                                <input type="number" v-model="valueModel.walls[iW].openings[iO].l">
                            </label>
                            <label class="option-label">
                                <span>Ширина, м</span>
                                <input type="number" v-model="valueModel.walls[iW].openings[iO].h">
                            </label>
                            
                            <button class="button-option-remove button-default" v-on:click="delOpening(iO,iW)"></button>
                        </div>
                    </div>
                    
                    <button class="button-default" v-on:click="addOpening(iW)">+ Добавить проем</button>
                </div>
                
                <div v-if="wallsS && wallsS[iW]<0">
                    <h4>Ошибка: площадь поверхности этой стены меньшу нуля</h4>
                    <p>измените размеры стены или проемов так чтобы они соответствовали реальным</p>
                </div>
                
            </div>
        </div>
        
        <button class="button-add-wall button-default" v-on:click="addWall">+ Добавить стену</button>
        
    </div>`
}
